import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExpandMoreSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExpandMoreSVG;
